// extracted by mini-css-extract-plugin
export default {"textButton":"text-button_textButton__R6-Yi"};